import { useEffect } from "react";
import { useGifsStore } from "../store";

export const useResetStore = () => {
  const reset = useGifsStore((s) => s.reset);

  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
};
